var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28C16.5 28 26 19.1156 26 12.375C26 9.8886 24.9991 7.50403 23.2175 5.74587C21.4359 3.98772 19.0196 3 16.5 3C13.9804 3 11.5641 3.98772 9.78249 5.74587C8.00089 7.50403 7 9.8886 7 12.375C7 19.1156 16.5 28 16.5 28ZM16.5 17.0625C15.2402 17.0625 14.032 16.5686 13.1412 15.6896C12.2504 14.8105 11.75 13.6182 11.75 12.375C11.75 11.1318 12.2504 9.93951 13.1412 9.06044C14.032 8.18136 15.2402 7.6875 16.5 7.6875C17.7598 7.6875 18.968 8.18136 19.8588 9.06044C20.7496 9.93951 21.25 11.1318 21.25 12.375C21.25 13.6182 20.7496 14.8105 19.8588 15.6896C18.968 16.5686 17.7598 17.0625 16.5 17.0625Z",
    fill: "#ABB2BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmark);
export default __webpack_public_path__ + "static/media/Landmark.0af87625c7b4dba537afd498426a4741.svg";
export { ForwardRef as ReactComponent };